









import Vue from "vue";
import { mapActions, mapMutations } from "vuex";

export default Vue.extend({
  name: "ProductsPage",
  components: {
    "product-list": () => import("./productsList.vue"),
    "product-form": () => import("./productsForm.vue"),
    "product-category": () => import("./productsCategory.vue"),
    "category-form": () => import("./categoryForm.vue")
  },
  methods: {
    ...mapMutations({
      resetQuery: "product/resetQuery"
    }),
    ...mapActions({
      checkShowMenu: "menu/checkShowMenu"
    })
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.resetQuery();
  }
});
